<template>
  <DxCheckBox
    :on-value-changed="onSelectionChanged"
    :validationMessageMode="validationMessageMode"
    :text="getLabelText"
    :rtlEnabled="true"
    :element-attr="checkBoxAttributes"
  >
  </DxCheckBox>
</template>
<script>
import DxCheckBox from "devextreme-vue/check-box";

export default {
  components: {
    DxCheckBox,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    checkBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      defaultValue: this.checkBoxOptions[0].defaultValue
        ? this.checkBoxOptions[0].defaultValue
        : undefined,
      validationMessageMode: this.checkBoxOptions[0].validationMessageMode
        ? this.checkBoxOptions[0].validationMessageMode
        : "auto",
      labelText: this.checkBoxOptions[0].label,
      checkBoxAttributes: {
        id: "form-check-box",
        class: "form-check-box-class",
      },
    };
  },
  created() {
  },
  computed: {
    getLabelText() {
      return this.labelText;
    },
  },
  methods: {
    onSelectionChanged(e) {
        let filter = [];
        var setFilter = [];

      if(e.value){
          setFilter = [];
          setFilter[0] = this.checkBoxOptions[0].dataField;
          setFilter[1] = "=";
          setFilter[2] = e.value;
          filter.push(setFilter);
      }

        if(this.checkBoxOptions[0].formLocation == 'form-report') {
          this.valueChangeCallBack(this.checkBoxOptions[0].dataField, e.value);
        }else this.valueChangeCallBack(this.checkBoxOptions[0].dataField, filter);
    },
    initialized(e) {
      if (this.defaultValue) {
        e.component.beginUpdate();
        e.component.option("value", this.defaultValue);
        e.component.endUpdate();
      }
    },
  },
};
</script>

<style lang="scss">
.form-check-box-class {
  .dx-checkbox-container .dx-checkbox-text {
    color: rgba(117, 117, 117, 0.87);
    font-size: 12px;
    text-align: end;
    padding-left: 5px;
  }
  .dx-checkbox-icon {
      margin-right: 5px;
  }
  padding: 16px 0 3px;
  width: 100%;
}
</style>
